import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatPriceNumber',
  standalone: true,
})
export class formatPriceNumber implements PipeTransform {
  transform(value: number): string {
    let ret = new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value));

    return ret.replace(/,00$/, '');
  }
}
